import { render, staticRenderFns } from "./OrdenArchivos.vue?vue&type=template&id=5e88fdf8&scoped=true&"
import script from "./OrdenArchivos.vue?vue&type=script&lang=js&"
export * from "./OrdenArchivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e88fdf8",
  null
  
)

export default component.exports